export default __webpack_public_path__ + "static/media/Scholar's Cowl of the Celestial Hilt.54805b05.jpg";